import { Box, CircularProgress, Container, Grid } from "@mui/material"
import { themePalette } from "../../config/theme.config"
import { I18nContext } from "../../I18nProvider";
import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import IresearhService from "../../services/IresearchService";
import { Autor, PublicacionActual } from "../../Interface/IPublicacion";
import { NotFoundPage } from "../Error/ErrorNotFound";

export const Publicacion: React.FC<{}> = () => {
    const context = useContext(I18nContext);
    const { id } = useParams<{ id: string }>();

    const [publicacionActual, setPublicacionActual] = useState<PublicacionActual>();
    const [loadingPub, setLoadingPub] = useState<Boolean>(true);
    const [autoresEspol, setAutoresEspol] = useState<Autor[]>([])
    const [autoresOtros, setAutoresOtros] = useState<Autor[]>([])
    const [notFound, setnotFound] = useState<boolean>(false);

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }

    useEffect(() => {
        if (id) {
            
            /*const newid = id.replace("@", "/")*/
            const newid = id
            IresearhService.GetPublicacionInfoByEid(newid)
                .then((pubActual) => {
                    if (!pubActual.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }
                    const proyectoAct: PublicacionActual = pubActual.data.publicacion;
                    const autEspol: Autor[] = pubActual.data.autoresEspol;
                    const autOtros: Autor[] = pubActual.data.otrosAutores
                    setPublicacionActual(proyectoAct);
                    setAutoresEspol(autEspol);
                    setAutoresOtros(autOtros);
                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingPub(false);
                });

        } else {
            console.log("No hay nombre unidad");
        }
    }, [id]);

    if (notFound) {
        return (

            <NotFoundPage />

        );
    }

    return (
		<Container >
            <h1>{context.t.translate("publicacion.publicacion")}</h1>
            <Grid container direction="row" justifyContent="center"  sx={{ borderTop: `2px solid ${themePalette.NAVCOLOR}` }} >
                
                <Grid item xs={12} sm={6} md={6}>
                    {loadingPub ? (
                        <CircularProgress />
                    ) : (
                        <Box>
                                <h3>{publicacionActual?.title}</h3>
                                <p><strong>{context.t.translate("publicacion.fecha")}: </strong> {publicacionActual?.coverDate}</p>
                                 
                                <p><strong>DOI:</strong> {publicacionActual?.doi && (
                                        <a href={`https://doi.org/${publicacionActual.doi}`} target="_blank" rel="noopener noreferrer">{publicacionActual.doi}</a>
                                    )}
                                </p>
                                <p><strong>{context.t.translate("publicacion.journal")}: </strong> {publicacionActual?.publicationName}</p>
                                {/*<p><strong>{context.t.translate("publicacion.articlenum")}: </strong> {publicacionActual?.articleNumber} </p>*/}

                                {(autoresEspol || []).length > 0 && (
                                    <Box>
                                        <h3>{context.t.translate("publicacion.investigadoresEspol")}</h3>
                                        <ul>
                                            {autoresEspol.map((colaborador, index) => { 
                                            const autor_url= `/investigador/${colaborador.scopusId}`;
                                                return (
                                                    
                                                <li key={index}>
                                                        <strong>{context.t.translate("proyecto.nombre")}:</strong> <Link to={autor_url}> {colaborador.indexedName}</Link> <br />
                                                    {/*<strong>Afiliación ID:</strong> {colaborador.affiliationId}*/}
                                                </li>
                                            )
                                            })}
                                        </ul>
                                    </Box>
                                )}
                                {(autoresOtros || []).length > 0 && (
                                    <Box>
                                        <h3>Otros Autores</h3>
                                        <ul>
                                            {autoresOtros.map((colaborador, index) => (
                                                <li key={index}>
                                                    <strong>{context.t.translate("proyecto.nombre")}:</strong> {colaborador.indexedName} <br />
                                                    {/*<strong>Afiliación ID:</strong> {colaborador.affiliationId}*/}
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                )}
                        </Box>
                    )}
                </Grid>
                
            </Grid>

		</Container>
	)
}